import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const NewMessageWarningPopup = styled.div`
  z-index: 1000;
  width: 241px;
  height: 103px;
  border-radius: 5px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
  background-color: ${colors.baseBackground};
  position: absolute;
  bottom: 115%;
  right: 0;
  padding: 12px;
  display: grid;
  grid-gap: 10px;
  grid-template-areas:
    'icon message'
    'buttons buttons';

  .Icon {
    width: 14px;
    height: 14px;
    grid-area: icon;
    background-image: ${(props) => 'url(' + props.iconName + ')'};
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 2px;
  }

  .Message {
    font-size: 9px;
    grid-area: message;
    margin: 0;
  }

  .Buttons {
    z-index: 1;
    margin-right: 0;
    margin-left: auto;
    grid-area: buttons;
    display: flex;
    justify-content: flex-end;
    justify-items: right;

    & > button {
      margin: 0;
      font-size: 8px;
      padding: 0 12px;
      height: 24px !important;
      margin-left: 5px !important;
      cursor: pointer;
    }
  }

  &::before {
    content: '';
    width: 30px;
    height: 30px;
    transform: rotate(45deg);
    background-color: ${colors.baseBackground};
    position: absolute;
    right: 8%;
    bottom: 0;
  }
`;
